import React from 'react';
import './Testimonials.css';

const Testimonials: React.FC = () => (
  <section className="testimonials">
    <h2>客户评价</h2>
    <div className="testimonial-card">
      <p>"AI工具让繁琐的数据核查变得轻松，团队效率提升显著！"</p>
      <div className="testimonial-user">
        <img src="http://www.auditai.com.cn/front-end/resource/image/avatar/SANQIN.png" alt="avatar" className="testimonial-avatar" />
        <div>
          <div>张少伟</div>
          <div className="testimonial-title">三秦会计师事务所 项目经理</div>
        </div>
      </div>
    </div>
  </section>
);

export default Testimonials; 